module.exports = __webpack_public_path__ + "static/media/an-logo-horizontal.418c44f3.svg";